import axios from "axios";
import { toast } from "react-toastify";
const protocol = window.location.protocol;

const instance = axios.create({
  //  baseURL: 'https://superplayerauction.com/dataapi/',
   baseURL: 'https://superplayerauction.com/dataapi/',
  //  baseURL: "http://localhost/auction/dataapi/", 
   /*headers: {
     "Content-Type": "multipart/form-data",
     "Accept": "application/json",
     "type": "formData"
   },*/
});

// Add a response interceptor
instance.interceptors.response.use(
  (response) => {
    // Any status code within the range of 2xx triggers this function
    // Check if the response indicates unauthorized access
    if (response.data && 
        response.data.success === false && 
        typeof response.data.msg === 'string' && 
        response.data.msg.includes("Unauthorized:")) {
      // Show toast message
      toast.error(response.data.msg, { theme: "colored" });
      
      // Clear local storage
      localStorage.clear();
      
      // Redirect to login page
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    }
    return response;
  },
  (error) => {
    // Any status codes outside the range of 2xx trigger this function
    if (error.response && error.response.status === 401) {
      // Handle 401 errors
      toast.error("Session expired. Please login again.", { theme: "colored" });
      
      // Clear local storage
      localStorage.clear();
      
      // Redirect to login page
      setTimeout(() => {
        window.location.href = '/';
      }, 1500);
    }
    return Promise.reject(error);
  }
);

export default instance;